function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5ZM13.1666 7.31458C12.8413 6.98931 12.318 6.98931 11.9928 7.31458L9.98459 9.32277L7.99055 7.32873C7.66528 7.00346 7.14202 7.00346 6.81676 7.32873C6.49149 7.654 6.49149 8.17725 6.81676 8.50252L8.8108 10.4966L6.80968 12.4977C6.65412 12.6532 6.56927 12.8654 6.5622 13.0846C6.56927 13.3038 6.65341 13.5152 6.80968 13.6715C7.13495 13.9967 7.65821 13.9967 7.99055 13.6785L9.99166 11.6774L11.9928 13.6785C12.318 14.0038 12.8413 14.0038 13.1666 13.6785C13.4918 13.3533 13.4918 12.83 13.1666 12.5047L11.1655 10.5036L13.1736 8.49545C13.4918 8.16311 13.4918 7.63985 13.1666 7.31458Z",
  fill: "#899296"
});

var SvgClearInput = function SvgClearInput(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClearInput, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clear_input.a965ae77.svg";
export { ForwardRef as ReactComponent };